import { LOCALE, isSupportedLang, type LANGUAGE } from '$lib/constants/locale';
import type { ParamMatcher } from '@sveltejs/kit';
export type LangCode = LANGUAGE;
export const LOCALES = LOCALE;
export const match: ParamMatcher = isSupportedLang;
